import { NgFor, NgIf } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ErrorMessages } from 'src/app/constants/errormessages.constants';
import { LoaderMessages } from 'src/app/constants/loadermessages.constants';
import { SuccessMessages } from 'src/app/constants/popup.constants';
import { PermissionEditRoleBody, UserRole } from 'src/app/model/common.model';
import { PopupSettings } from 'src/app/model/popup.model';
import { CommonService } from 'src/app/services/common.service';
import { TranslatorPipe } from '../../pipes/translator.pipe';
import { DialogService } from '../popup/popup.service';
import { UserGroups } from 'src/app/constants/user-groups.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatRipple,
    RouterLink,
    RouterLinkActive,
    MatIcon,
    MatButton,
    TranslatorPipe,
    MatMenuModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class HeaderComponent {
  roles: UserRole[] = UserGroups.Viewer;
  @ViewChild('userRoles', { read: TemplateRef, static: false }) userRolesTemplate!: TemplateRef<Element>;
  constructor(
    public readonly commonService: CommonService,
    private dialogSvc: DialogService
  ) {}

  changeRole() {
    this.commonService.userRole.setValue(this.commonService.role);
    const popupSettings: PopupSettings = {
      component: 'userManagement',
      headerText: 'Change Role',
      message: this.userRolesTemplate,
      buttonText: 'Confirm',
      disableClose: true,
      isTemplate: true,
      width: '400px',
      enableButton: true,
      showReason: true,
      data: { cur_role: this.commonService.role },
    };
    this.dialogSvc.$dialog(popupSettings).subscribe({
      next: (res: any) => {
        if (res && res != 'close') {
          this.commonService.isLoaderEnabled.next(true);
          this.commonService.loaderMessage.next(LoaderMessages.UpdateUser);
          const userEditRoleBody: PermissionEditRoleBody = {
            targetUserId: this.commonService.username,
            targetUserCurRole: this.commonService.role,
            targetUserEditedRole: this.commonService.userRole.value,
            logUserId: this.commonService.username,
            logUserRole: this.commonService.role,
            reason: this.commonService.reason.value.trim(),
            timezone: this.commonService.timezone,
          };
          this.commonService.editUserRole(userEditRoleBody).subscribe({
            next: () => {
              this.commonService.hideLoader(SuccessMessages.RaiseRoleChangeRequest, false);
            },
            error: (error: any) => {
              const token: string | null = localStorage.getItem('token');
              const errMsg: string = error?.['error']?.['error'];
              if (this.commonService.isTokenExpired(token))
                this.commonService.hideLoader(ErrorMessages.TokenExpired, true);
              else this.commonService.hideLoader(errMsg ? errMsg : ErrorMessages.RoleChangeRequestError, true);
            },
          });
        }
      },
      error: () => {
        this.commonService.hideLoader(ErrorMessages.PopupError, true);
      },
    });
  }
  changeUserRole(event: MatSelectChange) {
    this.commonService.userRole.patchValue(event.value);
  }
}
